module.exports = __webpack_public_path__ + "img/Gunnar-Ploehn-560.5e737e06.jpg";